export enum CommunityVisiblity {
	/** Non-members see all content. "All content" on the settings page. */
	Public,
	/** Non-members are stopped at the front door. "Locked Front Door" on the settings page. */
	Private,
	Hidden,

	/**
	 * SPACES ONLY — follow the parent community's answer. Rendered as the first option of the
	 * same picker, carrying the community's live value in its label ("Same as community ·
	 * Locked"), so inheritance is a value of the setting rather than a toggle beside it.
	 *
	 * ⚠️ Appended as 3 rather than reusing 2. `Hidden = 2` is a live value with its own meaning,
	 * and redefining it would silently reinterpret every space already stored as Hidden.
	 *
	 * A space created from now on defaults to this instead of copying the parent's value at
	 * creation time — copying makes a space that only *looks* like it follows, and stops
	 * following the moment the community changes.
	 *
	 * ⚠️ Never store this on a layer-0 community: there is nothing above it to inherit from.
	 * `effectiveVisiblity` below is the only correct way to read the column for a space.
	 */
	Inherit
}

/**
 * What a row's visibility actually resolves to.
 *
 * Call this rather than reading `Community.visiblity` directly whenever the row might be a
 * space — a raw read returns `Inherit`, which is not an answer to "can this person see it?".
 */
export const effectiveVisiblity = (
	visiblity: CommunityVisiblity,
	communityVisiblity: CommunityVisiblity
): CommunityVisiblity => (visiblity === CommunityVisiblity.Inherit ? communityVisiblity : visiblity)
